module.exports = __webpack_public_path__ + "static/media/manivela-varal.1ee4de0f.png";